const convertDropboxLinkToImage = (link) => {
    const modifiedLink = link.replace('dl=0', 'raw=1');
    return modifiedLink;
}
  
export default convertDropboxLinkToImage